import type { ParticipantDocument, ParticipantFile } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { ParticipantFilesAndDocumentsDeleteMenuItem } from './ParticipantFilesAndDocumentsDeleteMenuItem';

interface Props extends ChakraV3.ButtonProps {
  participantId: string;
  selectedRows: (ParticipantFile | ParticipantDocument)[];
}

export const ParticipantFilesAndDocumentsActionMenu = (props: Props) => {
  const { participantId, selectedRows, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='outline' size='sm' {...rest}>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ParticipantFilesAndDocumentsDeleteMenuItem
            participantId={participantId}
            selectedRows={selectedRows}
          />
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
